import '@css/main.scss'
import '@js/bootstrap'
import {Mask} from "@js/animations/Mask";
import {Slider} from "@js/utils/Slider";
import {Stagger} from "@js/animations/Stagger";
import {Wipe} from "@js/animations/Wipe";
import {Scroll} from "@js/animations/Scroll";
import {Background} from "@js/animations/Background";
import {Header} from "@js/components/Header";
import {Lightbox} from "@js/components/Lightbox";
import {CompanyGallery} from "@js/components/CompanyGallery";
import {Media} from "@js/components/Media";
import {CountNumber} from "@js/components/CountNumber";
import {Translate} from "@js/animations/Translate";
import {FormButton} from '@js/utils/FormButton'
import {EventForm} from '@js/components/EventForm'
import {TextOverflow} from "@js/animations/TextOverflow";
import {Parallax} from "@js/animations/Parallax";
import {Button} from "@js/components/Button";
import {Cursor} from "@js/utils/Cursor";
import {Puzzle} from "@js/utils/Puzzle";
import {TextVideo} from "@js/components/TextVideo";
import {Listener} from "./Listener";

window.onload = () => {

  const animations = [
    Mask,
    Stagger,
    Wipe,
    Scroll,
    Translate,
    Background,
    TextOverflow,
    Parallax
  ]

  animations.forEach(animation => {
    new animation()
  })

  new Slider()
  new Header()
  new Lightbox()
  new CompanyGallery()
  new Media()
  new CountNumber()
  new FormButton()
  new EventForm()
  new Button()
  new Cursor()
  new Puzzle()
  new TextVideo()
  new Listener()
}
